import { BRAND_MAPPING } from './constants'

export function buildUpdateUserRequest(params: {
  firstName: string
  lastName: string
  phone: string
}) {
  return {
    firstName: params.firstName,
    lastName: params.lastName,
    phone: params.phone,
  }
}

export function buildCreateUserRequest(params: {
  email: string
  language: string
  market: string
  password: string
}) {
  return {
    email: params.email,
    language: params.language,
    market: params.market,
    password: params.password,
  }
}

export function buildChangePasswordRequest(params: {
  currentPassword: string
  newPassword: string
}) {
  return {
    currentPassword: params.currentPassword,
    newPassword: params.newPassword,
  }
}

export function mapCreditCard(data: {
  brand: 'VIS' | 'Mas' | 'Ame'
  expirydate: string
  holder: string
  number: string
}) {
  return {
    brand: BRAND_MAPPING[data?.brand] || data?.brand,
    expiryDate: data?.expirydate,
    holder: data?.holder,
    number: data?.number,
  }
}
